export const environment = {
  production: false,
  mock: true,
};
